import { getPost, getParamsfilterEmpty } from "../../utils/request";
import { checkUnifyShop, unionFlag } from "../../utils";
/**
 * 获取微信签名
 * @param  {Object} params 请求的参数
 * @return
 */
export function getWxSignatureUrl(params) {
  const url = "/permission_valid_config/signature";
  return getPost(url, params, false);
}

/**
 * 快速搜索
 * @param  {Object} params 请求的参数
 * @return
 */
export function postQuick(params) {
  const url = "/search/searchContract/quick/v2";
  return getPost(url, params, false);
}

/**
 * 请求菜单
 * @param  {Object} params 请求的参数
 * @return
 */
export function postHead(params) {
  const url = "/search/searchHead";
  return getPost(url, params);
}

/**
 * tab新菜单
 * @param  {Object} params 请求的参数
 * @return
 */
export function postHeadNew(params) {
  const url = "search/searchContract/searchHead/v3";
  return getPost(url, params, false);
}

/**
 * 搜索结果
 * @param {params} params 请求的参数
 * @return
 */
export function postResult(params = {}) {
  const keys = Object.keys(params);
  keys.forEach((t) => {
    if (t === "productTypes") {
      // 因为接口出参跟入参不一致，现在写死强制转换
      // if (params[t] === '线下商户') {
      //   params[t] = '美食汇'
      // }
      // 因为接口迁移,后台要数组形式,后台调研此字段只会有一个值
      if ((params[t] === "" || params[t] === undefined) && !Array.isArray(params[t])) {
        params[t] = null
      } else if ((params[t] !== "" || params[t] !== undefined) && !Array.isArray(params[t])) {
        params[t] = params[t].split(",")
      }
    } else if (typeof (params[t]) == 'string' && params[t] === '') {
      params[t] = null
    }
  });
  const url = "search/searchContract/searchResult/v3";
  return getPost(url, params, false);
}

/**
 * 获取标签
 * @param {params} params 请求的参数
 * @return
 */
export function getTags(goodsList) {
  const params = {
    // channel: 2, //与后台沟通此接口不在需要此参数,
    goodsList: goodsList
  }
  const unionCode = unionFlag();
  if (unionCode || checkUnifyShop()) {
    params.expansivity = window.union_scale || 1;
  }
  const url = 'trade/promotion/tags';
  return getPost(url, params, false);
}

/*
 * 工会货币配置
 * @param {params} 参数
 * @return
 */
export function postUnionConfig(params) {
  const url = "/union/getunionconfig";
  return getPost(url, params, true, false);
}

/**
 * 商品信息
 * @param {params} params 请求的参数
 * @return
 */
export function getGoodsInfo(params) {
  const url = "/trade/goods/findGoodsSkus";
  return getPost(url, params, false);
}

/**
 * 检查登录
 * @param {params} params 请求的参数
 * @return
 */
export function checkLogin(params) {
  const url = "/user/checkLogin";
  return getPost(url, params, true, false);
}

/**
 * 检查登录
 * @param {params} params 请求的参数
 * @return
 */
export function addToCart(params) {
  const url = "/newCartContract/addCartItem";
  return getPost(url, params, false);
}

/**
 * 获取城市列表
 * @param {params} params 请求的参数
 * @return
 */
export function getCityList(params) {
  const url = "/location/citylist"
  return getPost(url, params, true, false);
}

/**
 * 获取用户地址列表
 * @param {params} params 请求的参数
 * @return
 */
export function getUserAddressList(params) {
  const url = "/address/userNewAddressContract/queryUserAddressList"
  return getPost(url, params, false, false);
}

/**
 * 获取地址信息
 * @param {params} params 请求的参数
 * @return
 */
export function getAddressInfo(params) {
  const url = "/trade/addressContract/getDefaultAddress";
  return getPost(url, params, false);
}

/**
 * 获取购物车数量
 * @param {params} params 请求的参数
 * @return
 */
export function getCartCount(params) {
  const url = "/newCartContract/userCartItemCount";
  return getPost(url, params, false);
}

/**
 * 获取搜索词链
 * @param {params} params 请求的参数
 * @return
 */
export function getSearchUrl(params) {
  const url = "/word/super";
  return getPost(url, params, false);
}

/**
 * 是否搜索敏感词
 * @param {params} params 请求的参数
 * @return
 */
 export function getSensitiveUrl(params) {
  const url = "/word/sensitive";
  return getPost(url, params, false);
}

/**
 * 获取省份列表
 * @param {params} params 请求的参数
 * @return
 */
export function getAllDistrict(params) {
  const url = "/trade/addressContract/getAllDistrict"
  return getPost(url, params, false, false);
}

/**
 * 获取省份下城市列表
 * @param {params} params 请求的参数
 * @return
 */
 export function getAllCityByProvince(params) {
  const url = "/trade/addressContract/getAllCityByProvince"
  return getPost(url, params, false, false);
}

/**
 * 获取城市下区域列表
 * @param {params} params 请求的参数
 * @return
 */
 export function getAllRegionByCity(params) {
  const url = "/trade/addressContract/getAllRegionByCity"
  return getPost(url, params, false, false);
}

/**
 * 获取区域下街道列表
 * @param {params} params 请求的参数
 * @return
 */
export function getAllStreetByRegion(params) {
  const url = "/trade/addressContract/getAllStreetByRegion"
  return getPost(url, params, false, false);
}

/**
 * 获取城市灰度
 * @param {params} params 请求的参数
 * @return
 */
export function getAddressGray(params) {
  const url = "/city/stock/gray/check"
  return getPost(url, params, false, false);
}


/**
 * 推荐广告位
 * @param {params} params 请求的参数
 * @return
 */
export function getRecommenGoods(params) {
  const url = "/search/searchAuxiliary/recommenGoods"
  return getPost(url, getParamsfilterEmpty(params), false, true, true);
}

/**
 * 底纹/发现
 * @param {params} params 请求的参数
 * @return
 */
 export function getWordList(params) {
  const url = "/word/list"
  return getPost(url, getParamsfilterEmpty(params), false, true, true);
}

/**
 * 推荐商品
 * @param {params} params 请求的参数
 * @return
 */
 export function getRecommendGoods(params) {
  const url = "/front/apollo/config"
  return getPost(url, getParamsfilterEmpty(params), false, true, true);
}
